import { useState } from "react";
import { faqList } from "@/mocks/news";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const toggle = (idx: number) => setOpenIdx((cur) => (cur === idx ? null : idx));

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
            <i className="ri-question-line" />
            FAQ
          </span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            常见问题
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-700">
            关于吃瓜51的更新频率、信源与投稿方式，这里都有答案。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqList.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.id}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-primary-200 bg-primary-50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <h3 className="flex items-center gap-3 font-heading text-base font-bold text-foreground-900 md:text-lg">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-500 text-xs font-bold text-background-50">
                      Q
                    </span>
                    {f.question}
                  </h3>
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-primary-500 transition-transform ${open ? "rotate-180" : ""}`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-700 md:px-6 md:pl-16 md:pb-6">
                      {f.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}